import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BrevoService {

  private apiUrl = 'https://api.brevo.com/v3/contacts';

  constructor(private http: HttpClient) {}

  addSubscriber(email: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'api-key': environment.brevoApiKey
    });

    const body = {
      email: email,
      listIds: [environment.brevoListId],
      updateEnabled: true
    };

    return this.http.post(this.apiUrl, body, { headers });
  }
}
